import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=6bd3be0c&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=6bd3be0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd3be0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bd3be0c')) {
      api.createRecord('6bd3be0c', component.options)
    } else {
      api.reload('6bd3be0c', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=6bd3be0c&scoped=true&", function () {
      api.rerender('6bd3be0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/quarterly-score-report-history/form/detail.vue"
export default component.exports